import initial from "lodash/initial";

export const setDifference = <T>(array1: T[], array2: T[]) =>
  array1.filter((elem) => !array2.includes(elem));

export const partition = <T>(array: T[], predicate: (element: T) => boolean) => {
  const matching: T[] = [];
  const notMatching: T[] = [];
  for (const x of array) {
    if (predicate(x)) {
      matching.push(x);
    } else {
      notMatching.push(x);
    }
  }
  return [matching, notMatching];
};

export const includesAll = <T>(needles: T[], haystack: T[]) =>
  needles.every((needle) => haystack.includes(needle));

export const intercalcate = <T>(list: T[], separator: (index: number) => T) =>
  initial(list.flatMap((item, index) => [item, separator(index)]));
